import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "title",
      to: "/"
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("onboard2", -1)
      ])),
      _: 1,
      __: [1]
    }),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "logout",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "ログアウト", -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}